import React from 'react';
import CreatableSelect from 'react-select/creatable';
import './style.scss';

export default function ReactSelectTag(props) {
    const { options, placeholder, onChange, selectedValues } = props;

    return (
        <CreatableSelect
            className='react-creatable-select'
            classNamePrefix="react-select"
            isMulti
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            value={selectedValues}
            
        />
    );
}

